import * as ChapterType from "utils/ChapterType";
import { getOptionalChapterEntity } from "selectors/chapter/makeGetChapterEntity";
import { createSelector } from "reselect";

export default createSelector(
  getOptionalChapterEntity,
  (optionalChapterEntity) => {
    if (optionalChapterEntity) {
      if (optionalChapterEntity.type === ChapterType.INTERVIEW) {
        return "Explainer";
      }
      return optionalChapterEntity.type;
    }
    return "";
  },
);
